import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstablishmentRedirectionService {

  private loading: boolean = false;
  private loadingStatus: Subject<any> = new Subject();

  getLoadingStatus(): Observable<any> {
    return this.loadingStatus.asObservable();
  }

  startLoading(campaignLink: string, dataRedirection: object) {
    this.loading = true;
    this.loadingStatus.next({
      loading: this.loading,
      campaignLink,
      dataRedirection,
    });
  }

  stopLoading() {
    this.loading = false;
    this.loadingStatus.next({
      loading: this.loading,
    });
  }
}